export default __webpack_public_path__ + "static/media/landing-are-you-ready.1c3638ff.jpg";